var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87891 8.13867V0.140625H4.93945V3.29883H2.00391V0.140625H0.0644531V8.13867H2.00391V4.86914H4.93945V8.13867H6.87891Z",
    fill: "#3D6BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2461 4.62891V3.69727C15.2461 1.43555 13.9453 0 11.6836 0C9.42188 0 8.10352 1.42383 8.10352 3.69727V4.62891C8.10352 6.87891 9.41016 8.28516 11.6719 8.28516C13.9395 8.28516 15.2461 6.87891 15.2461 4.62891ZM13.2656 3.67383V4.63477C13.2656 6.02344 12.6211 6.70898 11.6777 6.70898C10.7285 6.70898 10.084 6.02344 10.084 4.63477V3.67383C10.084 2.29102 10.7285 1.57031 11.6777 1.57031C12.6211 1.57031 13.2656 2.29102 13.2656 3.67383Z",
    fill: "#3D6BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5703 8.13867L20.9297 3.05859H21L22.3535 8.13867H24.1582L26.209 0.140625H24.1816L23.1504 5.50195H23.0625L21.7559 0.140625H20.1738L18.8672 5.50195H18.7852L17.7422 0.140625H15.7148L17.7656 8.13867H19.5703Z",
    fill: "#3D6BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74414 18.1387V11.7227H11.9238V10.1406H5.63672V11.7227H7.81055V18.1387H9.74414Z",
    fill: "#3D6BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4883 14.6289V13.6973C19.4883 11.4355 18.1875 10 15.9258 10C13.6641 10 12.3457 11.4238 12.3457 13.6973V14.6289C12.3457 16.8789 13.6523 18.2852 15.9141 18.2852C18.1816 18.2852 19.4883 16.8789 19.4883 14.6289ZM17.5078 13.6738V14.6348C17.5078 16.0234 16.8633 16.709 15.9199 16.709C14.9707 16.709 14.3262 16.0234 14.3262 14.6348V13.6738C14.3262 12.291 14.9707 11.5703 15.9199 11.5703C16.8633 11.5703 17.5078 12.291 17.5078 13.6738Z",
    fill: "#3D6BF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.7949C0.0175781 26.9551 0.791016 28.2852 3.23438 28.2852C5.32617 28.2852 6.52148 27.2656 6.52148 25.7012C6.52148 24.1836 5.47852 23.6152 4.33008 23.3926L3.16992 23.1582C2.47852 23.0234 2.09766 22.7598 2.09766 22.332C2.09766 21.8047 2.53125 21.4473 3.28711 21.4473C4.14844 21.4473 4.56445 21.9336 4.59961 22.4316H6.38672C6.36914 21.0664 5.22656 19.9883 3.29297 19.9883C1.50586 19.9883 0.169922 20.8848 0.169922 22.4844C0.169922 23.8789 1.11328 24.5234 2.29688 24.7578L3.42773 25.0039C4.20703 25.168 4.61133 25.3965 4.61133 25.8945C4.61133 26.4219 4.18945 26.8086 3.30469 26.8086C2.37305 26.8086 1.88086 26.3164 1.8457 25.7949H0Z",
    fill: "#3D6BF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 26.6035H9.62109V24.8223H12.8613V23.4043H9.62109V21.6758H13.0781V20.1406H7.70508V28.1387H13.0781V26.6035Z",
    fill: "#3D6BF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5645 26.5215H16.3594V20.1406H14.4199V28.1387H19.5645V26.5215Z",
    fill: "#3D6BF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6934 26.5215H22.4883V20.1406H20.5488V28.1387H25.6934V26.5215Z",
    fill: "#3D6BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToSell);
export default __webpack_public_path__ + "static/media/How_to_sell.a8e626feb1dec6bbcc04a4bb40b75c31.svg";
export { ForwardRef as ReactComponent };